import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import QuestionBlueIcon from '../../icons/QuestionBlueIcon.jsx';

class ExampleCSVDownloadButton extends React.PureComponent {
  state = {
    showModal: false,
  };

  handleClose = () => this.setState({ showModal: false });

  handleShow = () => this.setState({ showModal: true });

  renderModal = () => (
    <Modal bsSize="sm" show={this.state.showModal} onHide={this.handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Use the following steps to bulk upload stakeholders to the Stakeholder
          Structure:
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ol>
          <li className="text-muted">Download the Stakeholders CSV below.</li>
          <li className="text-muted">
            Edit the CSV and add the stakeholder details you want to include in
            the Stakeholder Structure.
          </li>
          <li className="text-muted">
            Save the edited or new file as a CSV and upload it to ChangeSync.
          </li>
        </ol>
      </Modal.Body>
      <Modal.Footer>
        <Button
          block
          bsStyle="primary"
          href="/static/structure-example.csv"
          target="_blank"
        >
          Download Example CSV
        </Button>
      </Modal.Footer>
    </Modal>
  );

  render() {
    return (
      <React.Fragment>
        <button
          aria-label="View help"
          type="button"
          className="btn-clear flex flex-align-center p-0 text-muted"
          onClick={this.handleShow}
        >
          Need a Stakeholder CSV Template? Click the question mark to download
          &nbsp;
          <QuestionBlueIcon />
        </button>
        {this.renderModal()}
      </React.Fragment>
    );
  }
}

export default ExampleCSVDownloadButton;
